import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, ResponseType } from '@angular/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiteStettingService {

  inMemoryUrl = "api/SelfServices/"
  loader:boolean = false;
  headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
  CaptchaNeeded:boolean;
  constructor(private _http: HttpClient) { }

  //option=credential&isAjax=true&g-recaptcha-response=&HIN_ID=0039274089&HIN_MOBILE=0526389961
  loginWithIdAndMobile(id: number, mobile: string, captchaResponse:any): Observable<any> {
    let req = {
      option: "credential",
      isAjax: true,
      HIN_ID: id,
      HIN_MOBILE: mobile
    }

    var formData: any = new FormData();
    formData.append('option', 'credential');
    formData.append('isAjax', true);
    formData.append('HIN_ID', id);
    formData.append('HIN_MOBILE', mobile);
    formData.append('g-recaptcha-response', captchaResponse);
    var queryString = new URLSearchParams(formData).toString();
    //return this._http.post<any>(this.inMemoryUrl+"loginWithIdAndMobile",req) ;
    return this._http.post(window['_serverUrl'], queryString, { headers: this.headers });
  }




  //option=credential&isAjax=true&g-recaptcha-response=&Ecom_Token=123456
  sendOtp(smp: number , captchaResponse: any): Observable<any> {
    let req = {
      option: "credential",
      isAjax: true,
      Ecom_Token: smp
    }


    var formData: any = new FormData();
    formData.append('option', "credential");
    formData.append('isAjax', true);
    formData.append('Ecom_Token', smp);
    formData.append('g-recaptcha-response', captchaResponse);
    var queryString = new URLSearchParams(formData).toString();
    //return this._http.post(this.inMemoryUrl+"sendOtp", req); 
    return this._http.post(window['_serverUrl'], queryString, { headers: this.headers });
  }

  //option=credential&initiateLoginSequence=true&isAjax=true
  restartLogin(): Observable<any> {
    console.log("call restartLogin in loginViaPassword")
    let req = {
      option: "credential",
      initiateLoginSequence: true,
      isAjax: true
    }
    var formData: any = new FormData();
    formData.append('option', 'credential');
    formData.append('initiateLoginSequence', true);
    formData.append('isAjax', true);
    var queryString = new URLSearchParams(formData).toString();
    //return this._http.post(this.inMemoryUrl + "restartLogin", req);
     return this._http.post(window['_serverUrl'], queryString, { headers: this.headers });
  }

  //option=credential&isAjax=true&g-recaptcha-response=&HIN_USERID=1234567&Ecom_Password=XXXXX
  loginWithIdAndPassword(id: number, password: string , captchaResponse:any): Observable<any> {
    var formData: any = new FormData();
    formData.append('option', "credential");
    formData.append('isAjax', true);
    formData.append('HIN_USERID', id);
    formData.append('Ecom_Password', password);
    formData.append('g-recaptcha-response', captchaResponse);
  
    var queryString = new URLSearchParams(formData).toString();
    //return this._http.post(this.inMemoryUrl + "loginWithIdAndPassword", formData);
    return this._http.post(window['_serverUrl'], queryString, { headers: this.headers });
  }

  //post to target
  postToGov() {
    let req = {
      option: "credential",
      target: "http://appslimud.education.gov.il/EduLogin/myaccount.aspx",
    }
    var formData: any = new FormData();
    formData.append('option', 'credential');
    formData.append('target', window['_target']);
    var queryString = new URLSearchParams(formData).toString();
    return this._http.post(window['_serverUrl'], queryString, { headers: this.headers });
  }

}
